import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import "../../App.css";
import Swal from "sweetalert2";
import { Card, Button, Spinner, Form, Pagination } from "react-bootstrap";
import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";

export default function MessageTimeline() {
  const [messages, setMessages] = useState(null);
  const [isLoading, setLoadingState] = useState(false);

  function Items({ currentItems }) {
    if (currentItems) {
      return (
        <>
          {currentItems
            .slice(0)
            .reverse()
            .map((item) => (
              <Card bg="info" className="mb-2 card1_">
                <Card.Header style={{ color: "#fff" }}>SecretSafe </Card.Header>
                <Card.Body>
                  <Card.Text
                    style={{
                      color: "#fff",
                      fontSize: "20px",
                      display: "flex",
                      justifyContent: "space-between",
                      display: "revert",
                    }}
                  >
                    {item.message}
                    <Button
                      onClick={() => deleteMessage(item._id)}
                      variant="light"
                      style={{
                        marginLeft: "10px",
                        width: "40px",
                        height: "40px",
                        borderRadius: "50px",
                        paddingLeft: "9.5px",
                      }}
                    >
                      <svg
                        style={{ width: "20px", height: "20px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </Button>
                  </Card.Text>
                </Card.Body>
                <Card.Header
                  style={{
                    color: "#fff",
                    borderTop: "1px solid rgba(0,0,0,.125)",
                  }}
                >
                  {item.response ? (
                    <Form.Text color="white">
                      Your response - "{item.response}"
                    </Form.Text>
                  ) : (
                    <Form
                      onSubmit={(params) => {
                        params.preventDefault();
                        respondMessage(item._id, params.target[0].value);
                      }}
                      style={{ display: "flex" }}
                    >
                      <Form.Control
                        placeholder="Respond"
                        style={{
                          borderTopRightRadius: "0",
                          borderBottomRightRadius: "0",
                          outline: "none",
                        }}
                      />
                      <Button
                        type="submit"
                        style={{
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                      >
                        Send
                      </Button>{" "}
                    </Form>
                  )}
                </Card.Header>
              </Card>
            ))}
        </>
      );
    }
  }

  function PaginatedItems({ itemsPerPage }) {
    // We start with an empty list of items.
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
      // Fetch items from another resources.
      const endOffset = itemOffset + itemsPerPage;
      if (messages) {
        setCurrentItems(messages.slice(itemOffset, endOffset));
      }
      setPageCount(Math.ceil(messages.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % messages.length;
      setItemOffset(newOffset);
    };

    return (
      <>
        <Items currentItems={currentItems} />
        {messages.length > 3 ? (
          <ReactPaginate
            breakLabel="..."
            nextLabel=">>"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<<"
            renderOnZeroPageCount={null}
            breakClassName="invisible"
            containerClassName="pagiCon"
            previousLinkClassName="btn btn-light prevBtn"
            activeClassName="bg-primary text-light"
            pageClassName="border"
            nextLinkClassName="btn btn-light nextBtn"
          />
        ) : (
          <></>
        )}
      </>
    );
  }
  useEffect(() => {
    setLoadingState(true);
    axios
      .get("https://secretsafe-backend.onrender.com/check-messages", {
        headers: {
          Authorization: localStorage.getItem("userToken"),
        },
      })
      .then((data) => {
        setLoadingState(false);
        if (data.data.response) {
          setMessages(data.data.response);
        }
      });
  }, []);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  function respondMessage(id, response) {
    setLoadingState(true);
    axios
      .post(
        "https://secretsafe-backend.onrender.com/send-respond/",
        {
          _id: id,
          response,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        },
      )
      .then((data) => {
        setLoadingState(false);
        console.log(data);
        if (data.data.response) {
          Toast.fire({
            icon: "success",
            title: data.data.response,
          });
          window.location.reload();
        }
        if (data.data.error) {
          Toast.fire({
            icon: "error",
            title: data.data.error,
          });
        }
      });
  }

  function deleteMessage(id) {
    axios
      .post("https://secretsafe-backend.onrender.com/delete-message", { id })
      .then((data) => {
        if (data.data.response) {
          Toast.fire({
            icon: "success",
            title: data.data.response,
          });
          window.location.reload();
        }
        if (data.data.error) {
          Toast.fire({
            icon: "error",
            title: data.data.error,
          });
        }
      })
      .catch((err) => {
        alert("A connection error has occured. Check your internet connection");
      });
  }

  if (!isLoading) {
    if (!messages?.length == false) {
      return (
        <Card
          style={{ alignItems: "center", padding: "15px", marginTop: "10px" }}
          className="mx-auto card__"
        >
          <Card.Title
            style={{
              fontSize: "25px",
              fontWeight: "800",
              textAlign: "center",
              paddingBottom: "0px",
            }}
          >
            Anonymous Message Timeline
          </Card.Title>
          <hr style={{ width: "100%" }} />
          <div>
            <PaginatedItems itemsPerPage={3} />
          </div>
        </Card>
      );
    } else {
      return (
        <Card
          style={{ alignItems: "center", padding: "15px", marginTop: "10px" }}
          className="mx-auto card__"
        >
          <Card.Title
            style={{
              fontSize: "25px",
              fontWeight: "800",
              textAlign: "center",
              paddingBottom: "0px",
            }}
          >
            Anonymous Message Timeline
          </Card.Title>
          <hr style={{ width: "100%" }} />
          <Card bg="dark" key="dark" className="mb-2 card1_">
            <Card.Header style={{ color: "#fff" }}>SecretSafe</Card.Header>
            <Card.Body>
              <Card.Text style={{ color: "#fff", fontSize: "20px" }}>
                You don't have any messages yet. Newer messages will appear
                here!
              </Card.Text>
            </Card.Body>
          </Card>
        </Card>
      );
    }
  } else {
    return (
      <Card
        style={{ alignItems: "center", padding: "15px", marginTop: "10px" }}
        className="mx-auto card__"
      >
        <Card.Title
          style={{
            fontSize: "25px",
            fontWeight: "800",
            textAlign: "center",
            paddingBottom: "0px",
          }}
        >
          Anonymous Message Timeline
        </Card.Title>
        <hr style={{ width: "100%" }} />
        <Spinner
          animation="border"
          role="status"
          style={{ height: "75px", borderWidth: "7px", width: "75px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Card>
    );
  }
}
